import React from "react";
import {Navbar,Footer} from '../dashboard';
import {useState,useEffect} from 'react';
import axios from "axios";
import configData from "../config.json";
import {useParams,Link} from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import { format } from "date-fns";
import { monthList,assetCategory } from '../utils/datalist';
import { Modal, Button, Form } from "react-bootstrap";

const IctEquipment=()=>{

    if(localStorage.getItem('branchID')===null){
        window.location.replace('/');
    }

    const [deptList,setDeptList]=useState([]);
    const [empData,setEmpData]=useState([]);
    const [assetData,setAssetData]=useState([]);
    const [inputData,setInputData]=useState([]);
    const [assetHistory,setAssetHistory]=useState([]);
    const [inputDataEdit,setInputDataEdit]=useState([]);
    const [empSearch,setEmpSearch]=useState();
    const [filter, setFilter] = useState(empData);
    

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showItem, setShowItem] = useState(false);
    const handleShowItem=()=>setShowItem(true);
    const handleCloseItem=()=>setShowItem(false);

    const getAssetData = async () => {
          const response=await axios.get(configData.SERVER_URL+`/assetData/${localStorage.getItem('branchID')}`)
          setAssetData(response.data);
        };

        const getDeptData = async () => {
            const deptRes=await axios.get(configData.SERVER_URL+`/deptData/${localStorage.getItem('branchID')}`);
            setDeptList(deptRes.data);  
        };

        const getEmpData = async () => {
          const responseEmp=await axios.get(configData.SERVER_URL+`/empData/${localStorage.getItem('branchID')}`)
          setEmpData(await responseEmp.data);
          setFilter(await responseEmp.data);
        };

    useEffect(() => {
        

        getDeptData();
        getEmpData();
        getAssetData();
  
    }, []);

    const setAssetID=async(assetID)=>{
        setInputData({...inputData,['assetID']:assetID});
        const response=await axios.get(configData.SERVER_URL+`/assetHistory/${assetID}`);
        setAssetHistory(response.data);
    }

    const handleInput=(e)=>{
        const {name,value}=e.target; 
        setInputData({...inputData,[name]:value});  
    }

    const handleInputEdit=(e)=>{
        const {name,value}=e.target; 
        setInputDataEdit({...inputDataEdit,[name]:value});  
    }

    const handleSubmit =async(e) => {
        e.preventDefault();
        try {
            let res=await axios.post(configData.SERVER_URL+`/assetHistory`,inputDataEdit);
            if(res.status===200){
                alert(res.data.message);

            } 
            } catch (error) {
            console.error('System error:', error);
        } 
        handleClose();
    };

    const editTarget=(data)=>{
        setInputDataEdit(data);
        handleShowItem();
    }

    const handleSubmitEdit =async(e)=>{
        e.preventDefault();
        try {
            let res=await axios.post(configData.SERVER_URL+`/assetUpdate`,inputDataEdit);
            if(res.status===200){
                alert(res.data.message);
                getAssetData();
            } 
            } catch (error) {
            console.error('System error:', error);
        } 
        handleCloseItem();
    }

    const filterEmployee=(e)=>{
    setEmpSearch(e.target.value);
    const updatedList = empData.filter((emp) => emp.empName.toLowerCase().includes(empSearch));
    setFilter(updatedList);
  }

    return(
        <>
        <Navbar/>
        <div className='container' style={{marginTop:100}}>
        

        <Modal show={show} onHide={handleClose} style={{marginTop:100}}>
        <Modal.Header closeButton>
          <Modal.Title>Repair/Maintanance History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Maintanance Date</Form.Label>
              <Form.Control type="date" id="repairDate" name="repairDate" value={inputData.repairDate} onChange={(e)=>{handleInput(e)}} required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Cost</Form.Label>
              <Form.Control type="number" id="cost" name="cost" value={inputData.cost} onChange={(e)=>{handleInput(e)}} required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Remarks</Form.Label>
              <Form.Control type="text" id="remarks" name="remarks" value={inputData.remarks} onChange={(e)=>{handleInput(e)}} />
            </Form.Group>
            <Button variant="success" type="submit">
              Submit
            </Button>
          </Form>
          <div className="card-body" style={{backgroundColor: "lavenderblush", padding: "20px", borderRadius: "10px"}}>
            <div className="table-responsive">
                <table class="table table-success table-hover table-bordered">
                    <thead>
                       <tr>
                        <th>Repair/Service Date</th>
                        <th>Cost</th>
                        <th>Remarks</th>
                        </tr> 
                    </thead>
                    <tbody>
                        {
                        assetHistory && assetHistory.length>0 && assetHistory.map((data,index)=>
                            <tr>
                                <td align="left">{data.repairDate && data.repairDate !== '0000-00-00' ? format(data.repairDate,"dd-MM-yyyy"):''}</td>
                                <td align="left">{Number(data.cost).toFixed(2).toLocaleString('en-IN')}</td>
                                <td>{data.remarks}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
          </div>
        </Modal.Body>
        
        </Modal>

        <Modal show={showItem} onHide={handleCloseItem} style={{marginTop:100, maxHeight: "80vh", overflowY: "auto",}}>
            <Modal.Header closeButton>
            <Modal.Title>Item Edit</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form onSubmit={handleSubmitEdit}>                 
            
                    <Form.Group className="mb-3">
                                            <Form.Label>Item Category</Form.Label>
                                            <Form.Select  id="assetCategory" name="assetCategory" value={inputDataEdit.assetCategory} disabled>
                                            <option value=''>---</option>
                                            {assetCategory.map(category => (
                                            <option key={category.code} value={category.code}>{category.name}</option>
                                            ))}
                                            </Form.Select>
                    </Form.Group>
            
                    <Form.Group className="mb-3">
                                        <Form.Label>Item Code</Form.Label>
                                        <Form.Control type="text"  name="assetCode" id="assetCode" value={inputDataEdit.assetCode} disabled></Form.Control>
                    </Form.Group>
                
                    <Form.Group className="mb-3">
                                        <Form.Label>Item Description</Form.Label>
                                        <Form.Control type="text"  name="description" id="description" value={inputDataEdit.description} onChange={(e)=>{handleInputEdit(e)}} ></Form.Control>
                    </Form.Group>    
                                      
                    <Form.Group className="mb-3">
                                            <Form.Label>User</Form.Label>
                                            <Form.Control type="text"  name="empSearch" id="empSearch" placeholder="Search by name" value={empSearch} onChange={(e)=>filterEmployee(e)}></Form.Control>
                                            <Form.Select  id="empID" name="empID" value={inputDataEdit.empID} onChange={(e)=>{handleInputEdit(e)}} required>
                                            <option value=''>---</option>
                                            {filter.map(data => (
                                                <option key={data.id} value={data.id}>{data.empCode} : {data.empName} : {data.deptName} </option>
                                            ))}
                                            </Form.Select>
                    </Form.Group>
                   
                    <Form.Group className="mb-3">
                                            <Form.Label>Assign Department</Form.Label>
                                            <Form.Select  id="deptID" name="deptID" value={inputDataEdit.deptID} onChange={(e)=>{handleInputEdit(e)}} required>
                                            <option value=''>---</option>
                                            {deptList.map(dept => (
                                            <option key={dept.id} value={dept.id}>{dept.deptName}</option>
                                            ))}
                                            </Form.Select>
                    </Form.Group>
            
                    <Form.Group className="mb-3">
                                            <Form.Label>Purchase Date</Form.Label>
                                            <Form.Control type="date"  id="purchaseYear" name="purchaseYear" value={inputDataEdit.purchaseYear} onChange={(e)=>{handleInputEdit(e)}}></Form.Control>
                    </Form.Group>
            
                    <Form.Group className="mb-3">
                                        <Form.Label>Purchase Price</Form.Label>
                                        <Form.Control type="number" name="price" id="price" value={inputDataEdit.price} onChange={(e)=>{handleInputEdit(e)}} ></Form.Control>
                    </Form.Group> 
            

                    <Form.Group className="mb-3">
                        <Button variant="success" type="submit" >Submit</Button>
                    </Form.Group>
                </Form>
            </Modal.Body>
        </Modal>

        <hr></hr>
        <div className="card well bg-info "> 
            <div className="card-header"> 
                ICT Equipment Information
                <Link to= {"/addEquipment"} >
                <button class="btn btn-md btn-success" style={{float:"right"}}>
                    <span><Icon.PlusCircle /></span>              
                </button>
                </Link>
            </div>
            <div className="card-body" style={{backgroundColor: "lavenderblush", padding: "20px", borderRadius: "10px"}}>
                <div className="table-responsive-sm table-responsive-md table-responsive-lg table-responsive-sl table-responsive-xxl">
                <table class="table table-success table-hover table-bordered">
                    <thead>
                        <tr>
                        <th>SL No.</th>
                        <th>Item Category</th>
                        <th>Item Code</th>
                        <th>Item Description</th>
                        <th>User</th>
                        <th>Department</th>
                        <th>Procurement Year</th>                                               
                        <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                        assetData && assetData.length>0 && assetData.map((data,index)=>
                        <tr align="right" key={data.id}>
                            <td align="left">{index+1}</td> 
                            <td align="left">{data.assetCategory}</td>  
                            <td align="left">{data.assetCode}</td>
                            <td align="left">{data.description}</td>
                            <td align="left">{data.empCode} : {data.empName}</td>
                            <td align="left">{data.deptName}</td>
                            <td align="left">{data.purchaseYear && data.purchaseYear !== '0000-00-00' ? format(data.purchaseYear,"dd-MM-yyyy"):''}</td>
                            <td>
                            
                            <button type="button" class="btn btn-info" onClick={() => {handleShow();setAssetID(data.id);}}>
                                <span><Icon.ThreeDots/></span>              
                            </button>
                            <button type="button" class="btn btn-info" onClick={()=>editTarget(data)}>
                                <span><Icon.Pencil/></span>              
                            </button>
                            </td>
                        </tr>
                        )}
                        
                    </tbody>
                </table>
                </div>
            </div>
        </div>
        
        </div>
        <Footer/>
        </>
    )

}

export default IctEquipment;